import { render, staticRenderFns } from "./EditAlt.vue?vue&type=template&id=338d9503&scoped=true&"
import script from "./EditAlt.vue?vue&type=script&lang=js&"
export * from "./EditAlt.vue?vue&type=script&lang=js&"
import style0 from "./EditAlt.vue?vue&type=style&index=0&id=338d9503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d9503",
  null
  
)

export default component.exports